import React, { useEffect, useRef, useState } from 'react';
import crossIcon from '../../../assets/nach-cancellation/crossIcon.svg';
import { useAuthStore } from '../../../redux';
import { useNachCancellationStore } from '../../../redux/features/nachCancellationSlice';
import { APP_ID, APP_VERSION } from '../../../utils';
import sendOTPExistingCustomerAPICall from '../helpers/send-otp-existing-customer';
import verifyOTPExistingCustomerAPICall from '../helpers/verify-otp-existing-customer';
import { useNavigate } from 'react-router-dom';
import { validateOtp } from '../../../utils/validations';
import { v4 as uuidv4 } from 'uuid';

const templateType = 'CANCEL_NACH';

const EnterOtpDrawer = ({ crossButtonClicked, handleLoadingState }) => {
  const [otpInput, setOtpInput] = useState('');
  const [timer, setTimer] = useState(60);
  const [error, setError] = useState('');

  const otpInputElement = useRef(null);

  const { panNumber } = useNachCancellationStore();
  const { customerId, customerRefNum, Authorization } = useAuthStore();
  const navigate = useNavigate();

  let sendOtpPayload = {
    customerRefNum,
    appId: APP_ID,
    appVersion: APP_VERSION,
    requestId: uuidv4(),
    panNo: panNumber,
    templateType: templateType,
    isResendOtp: false,
  };

  let verifyOtpPayload = {
    customerRefNum,
    panNo: panNumber,
    appId: APP_ID,
    appVersion: APP_VERSION,
    requestId: uuidv4(),
    otpCode: otpInput,
    templateType: templateType,
  };
  let interval;

  const handleInputChange = (e) => {
    setError('');
    const newOtp = e.target.value.trim();
    if (newOtp.length != 0) {
      let digitOnlyString = '';
      [...newOtp].forEach((singleDigit) => {
        if (singleDigit >= '0' && singleDigit <= '9') {
          digitOnlyString += singleDigit;
        }
      });
      setOtpInput(digitOnlyString.slice(0, 6));
      return;
    }
    setOtpInput(newOtp.slice(0, 6));
  };

  const sendOTPStartTimer = (timer) => {
    if (timer > 0) {
      setTimer((prev) => prev - 1);
      interval = setTimeout(() => sendOTPStartTimer(timer - 1), 1000);
    }
  };
  useEffect(() => {
    sendOTPStartTimer(timer);
  }, []);

  const handleResendOtp = () => {
    handleLoadingState(true);
    sendOTPExistingCustomerAPICall({
      customerCredentials: {
        customerId,
        Authorization,
        customerRefNum,
      },
      payload: sendOtpPayload,
      successFn: (res) => {
        console.log('RES SEND OTP ', res);
        setTimer(60);
        sendOTPStartTimer(60);
      },
      errorFn: (e) => {
        console.log(e);
      },
      finallyFn: () => handleLoadingState(false),
    });
  };

  const handleVerifyOtpClicked = () => {
    console.info(otpInput, validateOtp(otpInput));
    if (validateOtp(otpInput)) {
      handleLoadingState(true);
      verifyOTPExistingCustomerAPICall({
        customerCredentials: {
          customerId,
          Authorization,
          customerRefNum,
        },
        payload: verifyOtpPayload,
        successFn: (res) => {
          if (res?.statusCode !== 200) {
            setError(res.statusMsg);
          } else {
            navigate('/nach-cancellation/mandate-list');
          }
        },
        errorFn: (e) => {
          console.log(e);
        },
        finallyFn: () => {
          handleLoadingState(false);
        },
      });
    } else {
      setError('Enter 6-digit OTP');
    }
  };

  useEffect(() => otpInputElement.current.focus(), []);

  return (
    <>
      <div className="res150-overlay absolute top-0 left-0 right-0 bottom-0 w-full h-full  overflow-hidden bg-gray-700 opacity-75 z-[100]"></div>
      <div className="relative z-[110] h-full bg-white flex-col md:flex-row">
        <div className="flex items-center justify-between border-b border-stroke p-5">
          <h3 className="text-lg text-text-primary">Enter OTP</h3>
          <img
            className="cursor-pointer"
            onClick={crossButtonClicked}
            src={crossIcon}
            alt="crossIcon"
          />
        </div>
        <div className="p-5">
          <h3 className="text-text-secondary text-base mb-5">
            OTP successfully sent to registered mobile number
          </h3>
          <input
            onChange={handleInputChange}
            name="panInput"
            className={`border ${
              error.length >= 1
                ? 'border-warning'
                : otpInput.length >= 1
                ? 'border-[#079F9F] caret-[#079F9F]'
                : 'border-stroke'
            }  rounded w-full h-14 px-3`}
            placeholder="Enter OTP"
            value={otpInput}
            maxLength={6}
            ref={otpInputElement}
          />
          {error.length >= 1 && (
            <div className="flex flex-row">
              <div className="text-warning mt-2 ">{error}</div>
            </div>
          )}
          <button
            className={`text-accent text-sm mt-5 ${
              timer < 1 ? 'cursor-pointer' : 'cursor-text'
            }`}
            disabled={timer < 1 ? false : true}
            onClick={handleResendOtp}
          >
            {timer < 1 ? `Resend OTP` : `Resend OTP in 00:${timer} Sec`}
          </button>

          <button
            className={`${
              otpInput.length >= 1
                ? 'bg-accent cursor-pointer'
                : 'bg-background-stroke cursor-no-drop'
            } text-base text-white font-medium p-3 text-center rounded-md shadow-md w-full mt-4`}
            disabled={otpInput.length > 1 ? false : true}
            onClick={handleVerifyOtpClicked}
          >
            Verify OTP
          </button>
        </div>
      </div>
    </>
  );
};

export default EnterOtpDrawer;
